import acordeon from "../../lib/aria/acordeon";
const desplegables = () => {
    acordeon('.desplegables__opciones', false);
};
export default desplegables;
